import { useTranslation } from "react-i18next";

import { DashboardSummary } from "@components/organisms/dashboardSummary";
import { useGetMemberProfileStatistics } from "@api/system";
import { PaperDashboardView } from "@/view/dashboard/paperDashboardView";
import { Page } from "@components/atoms/page";
import { IPaperType } from "@constants";
import { Separator } from "@components/atoms/separator";

export function FacultyMemberDashboard() {
  const { t } = useTranslation("field");

  const { data, isFetching, isError } = useGetMemberProfileStatistics();

  return (
    <Page>
      <DashboardSummary
        items={[
          {
            key: "journalPaperCount",
            name: t("journalPaperCount"),
            value: data?.data?.total_journal_papers || 0,
          },
          {
            key: "conferencePaperCount",
            name: t("conferencePaperCount"),
            value: data?.data?.total_conference_papers || 0,
          },
          {
            key: "researchProposalCount",
            name: t("researchProposalCount"),
            value: data?.data?.total_research_projects || 0,
          },
          {
            key: "studentCount",
            name: t("studentCount"),
            value: data?.data?.total_students || 0,
          },
        ]}
        isLoading={isFetching}
        isError={isError}
      />
      <Separator />
      <PaperDashboardView type={IPaperType.journal} />
      <Separator />
      <PaperDashboardView type={IPaperType.conference} />
    </Page>
  );
}
